<section>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6 flex gap-2">
      <button
        type="button"
        pButton
        icon="fa fa-plus"
        (click)="crearVariable()"
        label="{{ 'BTN_AGREGAR' | translate }}"
      ></button>
      <button
        type="button"
        pButton
        icon="fa fa-server"
        label="{{ 'SARLAFT.LBL_COMPROBAR' | translate }}"
        (click)="modalSimulador()"
      ></button>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-table
        [columns]="columnas"
        [loading]="carVariables"
        #dt
        [value]="variables"
        selectionMode="single"
        dataKey="idVariable"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">
              {{
                !row?.codigoVariableSarlaft ? " - " : row?.codigoVariableSarlaft
              }}
            </td>
            <td class="text-center">
              {{ !row?.variableSarlaft ? " - " : row?.variableSarlaft }}
            </td>
            <td class="text-center">{{ !row?.peso && row?.peso !== 0  ? " - " : row?.peso + '%' }}</td>
            <td class="text-center">
              {{ !row?.cantidadCondiciones && row?.cantidadCondiciones !== 0 ? " - " : row?.cantidadCondiciones }}
            </td>
            <td class="text-center">
              {{ !row?.valorDefecto && row?.valorDefecto !== 0 ? " - " : row?.valorDefecto }}
            </td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorDeterminante"
                binary="true"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorHabilitado"
                binary="true"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button btn"
                  icon="fa fa-eye"
                  data-toggle="tooltip"
                  title="{{ 'BTN_VISUALIZAR' | translate }}"
                  pButton
                  (click)="verVariable(row)"
                ></button>
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  *ngIf="menu.editar"
                  (click)="editarVariable(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>
